define(["require", "exports", "tslib", "numeral"], function (require, exports, tslib_1, numeral_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.currency = void 0;
    numeral_1 = tslib_1.__importDefault(numeral_1);
    function currency(x) {
        return (0, numeral_1.default)(typeof x == "string" ? parseFloat(x) : x).format('$0,0.00');
    }
    exports.currency = currency;
});
